namespace TabAurous.OMS {
    export interface CustomerRow {
        LedgerId?: number;
        PartyType?: string;
        PartyCode?: string;
        LedgerName?: string;
        CustomerPrefix?: string;
        AccountGroupId?: number;
        Nature?: string;
        TermId?: number;
        MailingName?: string;
        Email?: string;
        BillbyBill?: boolean;
        IsDisabled?: boolean;
        MarkUpPolicyId?: number;
        TaxRegType?: string;
        GstVat?: string;
        Pan?: string;
        CurrencyId?: number;
        LbrFlag?: boolean;
        StnFlag?: boolean;
        LbrFromDate?: string;
        LbrToDate?: string;
        LbrPricegroupId?: number;
        LbrAddDisc?: number;
        LbrAddMkp?: number;
        StnFromDate?: string;
        StnToDate?: string;
        CostPricegroupId?: number;
        StnAddDisc?: number;
        StnAddMkp?: number;
        Coef?: number;
        AddressDetails?: AddressMasterRow[];
        ContactDetails?: ContactDetailsRow[];
        Token?: string;
        APIEndpoint?: string;
        AutoCreateVoucherUsingAPI?: boolean;
        APIToken?: string;
        AutoPosting?: boolean;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace CustomerRow {
        export const idProperty = 'LedgerId';
        export const nameProperty = 'LedgerName';
        export const localTextPrefix = 'OMS.Customer';
        export const deletePermission = 'Customer:Delete';
        export const insertPermission = 'Customer:Add';
        export const readPermission = '*';
        export const updatePermission = 'Customer:Edit';

        export declare const enum Fields {
            LedgerId = "LedgerId",
            PartyType = "PartyType",
            PartyCode = "PartyCode",
            LedgerName = "LedgerName",
            CustomerPrefix = "CustomerPrefix",
            AccountGroupId = "AccountGroupId",
            Nature = "Nature",
            TermId = "TermId",
            MailingName = "MailingName",
            Email = "Email",
            BillbyBill = "BillbyBill",
            IsDisabled = "IsDisabled",
            MarkUpPolicyId = "MarkUpPolicyId",
            TaxRegType = "TaxRegType",
            GstVat = "GstVat",
            Pan = "Pan",
            CurrencyId = "CurrencyId",
            LbrFlag = "LbrFlag",
            StnFlag = "StnFlag",
            LbrFromDate = "LbrFromDate",
            LbrToDate = "LbrToDate",
            LbrPricegroupId = "LbrPricegroupId",
            LbrAddDisc = "LbrAddDisc",
            LbrAddMkp = "LbrAddMkp",
            StnFromDate = "StnFromDate",
            StnToDate = "StnToDate",
            CostPricegroupId = "CostPricegroupId",
            StnAddDisc = "StnAddDisc",
            StnAddMkp = "StnAddMkp",
            Coef = "Coef",
            AddressDetails = "AddressDetails",
            ContactDetails = "ContactDetails",
            Token = "Token",
            APIEndpoint = "APIEndpoint",
            AutoCreateVoucherUsingAPI = "AutoCreateVoucherUsingAPI",
            APIToken = "APIToken",
            AutoPosting = "AutoPosting",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
